const Component = {
  "图片 url 不存在": "画像のURLが存在しません",
  "暂不支持下载此类型图片": "このタイプの画像のダウンロードは現在サポートされていません",
}

export default Component;